import { render } from "./CreateShiftsCard.vue?vue&type=template&id=11ef0087&scoped=true"
import script from "./CreateShiftsCard.vue?vue&type=script&lang=js"
export * from "./CreateShiftsCard.vue?vue&type=script&lang=js"

import "./CreateShiftsCard.vue?vue&type=style&index=0&id=11ef0087&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ef0087"]])

export default __exports__